<style lang="scss" scoped>
.custom-progress-line {
  width: 100%;
  height: 5px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .line {
    width: 2.03px;
    height: 4.99px;
    background: rgba(45, 130, 255, 0.2);
  }
  .active{
    background: #2D82FF;
  }
}
</style>

<template>
  <div class="custom-progress-line">
    <div class="line" v-for="(item, index) of getList" :class="item.class" :key="index"></div>
  </div>
</template>


<script>
export default {
  name: "custom-progress-line",
  props: {
    value: Number,
    splitCount: Number,
  },
  computed: {
    getList() {
      let result = [];

      for (let index = 0; index <= this.splitCount; index++) {
        if(index/this.splitCount*100<=this.value){
        result.push({class:"active"});
        }else{
        result.push({class:""});
        }
      }

      return result;
    },
  },
};
</script>